import Status from '../../../elements/Status'
import React from 'react'

/**
 * @return {null}
 */
export default function StatusCell({ value }) {
  return value ? <Status value={value} tooltip={false} /> : null
}
